/*
  c-ugc: mouse drag on the rail (touch and trackpads scroll natively) and
  click-to-play for video tiles (the <video> lives in a <template> until asked for).
*/
(() => {
  const DRAG_THRESHOLD = 5;

  const initRail = (rail) => {
    if (rail.dataset.cUgcReady) return;
    rail.dataset.cUgcReady = 'true';

    let startX = 0;
    let startScroll = 0;
    let pointerId = null;
    let moved = false;

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('button, a, video')) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
      moved = false;
    });

    rail.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      if (!moved && Math.abs(dx) < DRAG_THRESHOLD) return;
      if (!moved) {
        moved = true;
        rail.setPointerCapture(pointerId);
        rail.classList.add('is-dragging');
      }
      rail.scrollLeft = startScroll - dx;
    });

    const end = (event) => {
      if (event.pointerId !== pointerId) return;
      pointerId = null;
      if (!moved) return;
      const left = rail.scrollLeft;
      rail.classList.remove('is-dragging');
      // Re-enabling scroll-snap jumps instantly; restore the position and glide to the snap point.
      rail.scrollLeft = left;
      rail.scrollBy({ left: 0, behavior: 'smooth' });
    };

    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);

    rail.addEventListener('click', (event) => {
      const play = event.target.closest('[data-c-ugc-play]');
      if (!play) return;
      const tile = play.parentElement;
      const template = tile.querySelector('template[data-c-ugc-video]');
      if (!template) return;
      tile.querySelector('img')?.remove();
      play.remove();
      tile.append(template.content.cloneNode(true));
      template.remove();
      const video = tile.querySelector('video');
      if (video) {
        video.focus();
        video.play().catch(() => {});
      }
    });
  };

  const init = (root = document) => root.querySelectorAll('[data-c-ugc-rail]').forEach(initRail);

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
